/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useLayoutEffect, useCallback } from "react";
import styles from "../HomeScreen.module.css";
import { useHistory, useLocation } from "react-router-dom";
import VoiceService from "../../voice-agent/VH-Myra-FrontEnd";
import { AnalyticsService } from "../analytics/AnalyticsService";
import { usePreventNavigation, BrowserBlockScreen } from "../SelfAssessmentUi";
import checkBrowserSupport from "../browserDetect";
import SelfAssessment2 from "../SelfAssessment";
import { IS_UAT } from "../CONSTANTS";

// ============================================================
// LOGO URL
// ============================================================
const LOGO_URL = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/LogoPNG.png";
const HAMBURGER_ICON_SVG = (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <rect x="3" y="5" width="18" height="2.6" rx="1.3" />
    <rect x="3" y="10.7" width="18" height="2.6" rx="1.3" />
    <rect x="3" y="16.4" width="18" height="2.6" rx="1.3" />
  </svg>
);

// ============================================================
// useScrollToTop — local utility
// ============================================================
const useScrollToTop = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

// ============================================================
// trackAnalytics — shared analytics helper
// ============================================================
const trackAnalytics = (newFields) => {
  if (AnalyticsService?.trackStep) {
    try {
      const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};
      const updatedData = {
        ...existingData,
        ...newFields,
        session_last_update: new Date().toISOString(),
      };
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);
    } catch (err) {
      console.error("Analytics error:", err);
    }
  }
};

// ============================================================
// CustomHeader — Simplified nav bar
// Matches prototype: logo left (half-size), About Us centered,
// Member Login right (outlined button)
// ============================================================
export const CustomHeader = ({ setShowMemberBlockScreen, isComeFromGoogle, onIntroAction, hideContent, handleHomeVideoClicked, handleWhoIsMyraClick }) => {
  const history = useHistory();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleWatchVideoClick = () => {
    if (onIntroAction) {
      onIntroAction("video");
    }
  };

  const handleWhoIsMyraClickLocal = () => {
    if (onIntroAction) {
      onIntroAction("myra");
    }
  };

  const handleLoginClick = () => {
    const check = checkBrowserSupport("member");
    if (!check.isSupported) {
      setShowMemberBlockScreen(true);
      return;
    }

    // set cameFromGsaV2 to false when click login
    localStorage.setItem("cameFromGsaV2", "false");
    window.loadedROM = false;
    window.clickedOnceOpen = false;
    window.movementTestPayload = null;
    window.cameraPayload = null;
    window._gsaLandingChatMovementTest = false;

    if (window.isStartedLandingFlow || window.mayraCode) {
      window.mayraCode?.setIsVisible(false);
      VoiceService.destroyMyraCompletely(false);
    }

    trackAnalytics({ userMoveBetweenSubPage: true });

    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();
    window.isThisFromHomeScreen = false;

    if (window.turnOffCamera) window.turnOffCamera();

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader?.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";
      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");
      window.doNextLocation = history;
      document.querySelector("html").classList = [];

      if (window.isFlutterLoaded && typeof window.navigateToMemberLogin === "function") {
        window.navigateToMemberLogin();
      }

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <>
      {!window.hideNavbar && (
        <nav className={styles.navBar}>
          <div className={styles.navMobileMenu}>
            <button className={styles.navHamburgerBtn} onClick={() => setIsMobileMenuOpen((prev) => !prev)} aria-label="Open navigation menu" aria-expanded={isMobileMenuOpen}>
              {HAMBURGER_ICON_SVG}
            </button>
            {isMobileMenuOpen && (
              <div className={styles.navHamburgerMenu}>
                <button
                  className={styles.navMenuItem}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleWatchVideoClick();
                  }}
                >
                  Watch a Video
                </button>
                <button
                  className={styles.navMenuItem}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleWhoIsMyraClickLocal();
                  }}
                >
                  Who is Myra?
                </button>
                <button
                  className={styles.navMenuItem}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    trackAnalytics({
                      visitedAbout: true,
                      userMoveBetweenSubPage: true,
                    });
                    history.push("/about");
                  }}
                >
                  About Us
                </button>
              </div>
            )}
          </div>
          <a className={styles.navLogo} href="https://www.virdiohealth.com" target="_blank" rel="noopener noreferrer" title="Virdio Health">
            <img
              src={LOGO_URL}
              alt="Virdio Health"
              className={styles.navLogoImg}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/128x32/e2e8f0/475569?text=VirdioHealth";
              }}
            />
          </a>

          <div className={styles.navCenter}>
            <button className={`${styles.navLink} ${styles.navDesktopOnly}`} onClick={handleWatchVideoClick}>
              Watch a Video
            </button>
            <button className={`${styles.navLink} ${styles.navDesktopOnly}`} onClick={handleWhoIsMyraClickLocal}>
              Who is Myra?
            </button>
            <button
              className={`${styles.navLink} ${styles.navDesktopOnly}`}
              onClick={() => {
                trackAnalytics({
                  visitedAbout: true,
                  userMoveBetweenSubPage: true,
                });
                history.push("/about");
              }}
            >
              About Us
            </button>
          </div>

          <button className={styles.navLogin} onClick={handleLoginClick}>
            Login
          </button>
        </nav>
      )}
      {!window.hideNavbarBtm && (
        <div className={styles.headlineArea}>
          <h1 className={styles.headline}>Exercises &amp; Stretches for Back Pain Relief, Tailored by AI-Powered Myra</h1>
          <p className={styles.headlineSub}>Myra is your AI recovery coach, built with Doctors of Physical Therapy. Get your free, at-home exercise plan in about 5 minutes.</p>
        </div>
      )}
    </>
  );
};

// ============================================================
// HomeScreen — Main landing page component (revised)
//
// Architecture:
//   Landing page renders a dark headline card + white GSA card.
//   SelfAssessment mounts inside the card in "embedded" mode.
//   "Let's get started" triggers a fade-out transition, then
//   the GSA switches to "fullscreen" mode.
// ============================================================
export const HomeScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();

  // ── Infrastructure state (preserved from original) ──
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const [assessmentData, setAssessmentData] = useState(() => {
    try {
      const raw = localStorage.getItem("assessmentData");
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      console.error("Error reading assessmentData:", error);
      return {};
    }
  });
  const updateAssessmentData = useCallback((updates) => {
    setAssessmentData((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const [isComeFromGoogle, setIsComeFromGoogle] = useState(false);
  const [isUserCameBackAgain, setIsUserCameBackAgain] = useState(false);
  const [userVariant, setUserVariant] = useState(null);

  // Tracks whether user engaged with Myra on the landing page
  const [myraEngaged, setMyraEngaged] = useState(false);
  const [myraChatCount, setMyraChatCount] = useState(0);

  // ── Transition state ──
  const [gsaMode, setGsaMode] = useState("embedded"); // "embedded" | "transitioning" | "fullscreen"
  const [introExternalAction, setIntroExternalAction] = useState(null);
  const landingWrapperRef = useRef(null);
  const [mode, setMode] = useState("chat");
  const handleVoiceClicked = () => {
    setMode("voice");
    window?.MyraInteraction?.switchMode("voice");
    if (window?.mayraCode) {
      window?.mayraCode.handlePickVoice();
    }
  };
  const handleChatClicked = () => {
    VoiceService.stopCompletely();
    VoiceService._releaseMic();
    window?.MyraInteraction?.switchMode("chat");
    setMode("chat");
    if (window?.mayraCode) {
      window?.mayraCode.handlePickChat();
    }
  };

  const CHAT_ICON_SVG = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
  const VOICE_ICON_SVG = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    </svg>
  );
  const history = useHistory();
  const { search } = useLocation();

  localStorage.removeItem("startedSelf");

  // ── URL parameter routing ──
  useEffect(() => {
    const step = new URLSearchParams(search).get("step");
    if (!step) return;
    if (step === "askmyra" || step === "howitworks" || step === "aboutvirdio" || step === "startnow") {
      localStorage.setItem("isV2", "true");
    }

    switch (step) {
      case "askmyra":
        history.replace("/ask-myra");
        break;
      case "howitworks":
        history.replace("/how-it-works");
        break;
      case "aboutvirdio":
        history.replace("/about");
        break;
      // case "startnow":
      //   handleStartAssessment();
      // break;
      default:
        break;
    }
  }, [search, history]);

  // ── Session initialization ──
  useEffect(() => {
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    if (previousSessionIdExits) {
      localStorage.removeItem("trSessionId");
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }
    window.screenTracker.enterScreen("landing");

    // Repeat visitor detection
    const isRepeat = localStorage.getItem("isUserCameBackAgain") === "true";
    if (isRepeat) {
      setIsUserCameBackAgain(true);
    }
    localStorage.setItem("isUserCameBackAgain", "true");

    // URL param detection (variant / gclid)
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const urlVariant = params.get("variant");
    const resolvedVariant = urlVariant || localStorage.getItem("variant") || null;

    if (urlVariant) {
      localStorage.setItem("variant", urlVariant);
    }

    const isFromGoogle = !!(gclid || resolvedVariant);
    if (resolvedVariant) setUserVariant(resolvedVariant);
    if (isFromGoogle) setIsComeFromGoogle(true);

    // Check whether the user came to the landing page from a subpage this session.
    // Subpages set this marker on page load; we consume it so it only fires once.
    const cameFromSubpage = localStorage.getItem("visitedSubpageBeforeLanding") === "true";
    if (cameFromSubpage) {
      localStorage.removeItem("visitedSubpageBeforeLanding");
    }

    // Build tracking fields for session creation
    const trackingFields = {
      variant: resolvedVariant,
      isComeFromGoogle: isFromGoogle,
      isUserCameBackAgain: isRepeat,
      cameToLandingPage: cameFromSubpage,
    };

    const initializeSession = async () => {
      await AnalyticsService.startSession(trackingFields);
    };

    // if (window?.timeTracker) {
    //   window?.timeTracker?.startLandingTimer();
    // }

    fetch("https://virdio.weborik.com/init.php")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.session;
      })
      .catch((error) => {
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        initializeSession();
      });
  }, []);

  useEffect(() => {
    window.isThisFromHomeScreen = true;
    window.MyraInteraction.onScreenEnter("intro");
    return () => {
      window.isThisFromHomeScreen = false;
    };
  }, []);

  // ── Transition: Landing → Fullscreen GSA ──
  //
  // Called by SelfAssessment via the onStartAssessment prop.
  // 1. Fire Google Ads conversion
  // 2. Track analytics payload
  // 3. Fade out landing wrapper
  // 4. Switch GSA to fullscreen mode
  //
  const handleStartAssessment = useCallback(() => {
    const trackingFields = {
      variant: userVariant,
      isComeFromGoogle: isComeFromGoogle,
      isUserCameBackAgain: isUserCameBackAgain,
    };

    if (!window.trSessionId) {
      AnalyticsService.startSession(trackingFields);
    }
    // Google Ads conversion tracking
    try {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
        });
      }
    } catch (e) {
      console.warn(e);
    }

    // Screen tracking
    window.screenTracker.exitScreen("landing", {
      exitReason: "started_gsa",
      completed: true,
    });

    const finalScreenFlow = window.screenTracker.getScreenFlow();
    const timingData = window.timeTracker.startGSATimer();

    let landingDurationSec = null;
    if (finalScreenFlow.length > 0) {
      const landingScreen = finalScreenFlow.find((s) => s.screen === "landing");
      if (landingScreen && landingScreen.enteredAt && landingScreen.exitedAt) {
        const start = new Date(landingScreen.enteredAt);
        const end = new Date(landingScreen.exitedAt);
        landingDurationSec = Math.round((end - start) / 1000);
      }
    }

    // Analytics payload
    const updatedData = {
      ...assessmentData,
      started_assessment: true,
      myraEngagedLanding: myraEngaged,
      myraInteractionMode: "chat", // New design is chat-only on landing
      myraChatMessagesCount: myraChatCount,
      isComeFromGoogle: isComeFromGoogle,
      isUserCameBackAgain: isUserCameBackAgain,
      variant: userVariant,
      ...timingData,
      screenFlow: finalScreenFlow,
      gsaStartedAt: timingData,
      homeVideoWatch: window?.isHomeVideoWatch || false,
      timeOnLandingSec: landingDurationSec,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      session_last_update: new Date().toISOString(),
      EngagedOnLanding: myraEngaged,
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    // ── Begin transition animation ──
    setGsaMode("transitioning");

    // After the CSS exit animation completes (~400ms), switch to fullscreen
    setTimeout(() => {
      setGsaMode("fullscreen");
    }, 450);
  }, [assessmentData, updateAssessmentData, myraEngaged, myraChatCount, isComeFromGoogle, isUserCameBackAgain, userVariant]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const step = params.get("step");
    const gsa = params.get("gsa");

    if (gsa === "v2" && step === "startnow") {
      localStorage.setItem("isV2", "true");
      handleStartAssessment();
    }
  }, [search, handleStartAssessment]);

  // ── Callback: GSA reports user engagement ──
  // Called by the embedded GSA whenever the user sends a message
  // or taps a quick-reply (other than "Let's get started").
  const handleMyraEngagement = useCallback((chatCount) => {
    setMyraEngaged(true);
    if (typeof chatCount === "number") {
      setMyraChatCount(chatCount);
    }

    // Write engagement to DB immediately so bounced users are still counted.
    // This fires on every engagement event but the DB write is idempotent —
    // flipping `myra_engaged_landing` from 1 to 1 has no effect, and the
    // turn counters will simply reflect the latest state.
    const turnCount = typeof chatCount === "number" ? chatCount : 0;
    trackAnalytics({
      myraEngagedLanding: true,
      myraChatMessagesCount: turnCount,
      myraConversationCount: turnCount,
      myraTotalTurns: turnCount,
    });
  }, []);

  // ── Render ──

  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="member" />;
  }

  // ── FULLSCREEN MODE: GSA takes over the entire viewport ──
  if (gsaMode === "fullscreen") {
    return (
      <div className={styles.gsaFullscreen}>
        <SelfAssessment2 displayMode="fullscreen" onMyraEngagement={handleMyraEngagement} />
      </div>
    );
  }

  // ── LANDING PAGE (embedded mode + transitioning) ──
  const isExiting = gsaMode === "transitioning";

  return (
    <div className={styles.appShell}>
      <div ref={landingWrapperRef} className={`${styles.landingWrapper} ${isExiting ? styles.landingExiting : ""}`}>
        {/* ── Nav Bar ── */}
        <CustomHeader
          setShowMemberBlockScreen={setShowMemberBlockScreen}
          onIntroAction={(type) => {
            setIntroExternalAction({ type });
          }}
          isComeFromGoogle={isComeFromGoogle}
        />
        <div className={styles.navDivider} />

        {/* ── Headline Area (dark, rounded bottom) ── */}
        <div className={styles.headlineArea}>
          <h1 className={styles.headline}>Exercises &amp; Stretches for Back Pain Relief, Tailored by AI-Powered Myra</h1>
          <p className={styles.headlineSub}>Myra is your AI recovery coach, built with Doctors of Physical Therapy. Get your free, at-home exercise plan in about 5 minutes.</p>
        </div>

        {/* ── GSA Card Frame ── */}
        <div className={styles.cardSurround}>
          <div className={styles.cardFrame}>
            {/* Card header bar */}
            <div className={styles.cardHeader}>
              <div className={styles.cardSubHeader}>
                <div className={styles.myraAvatar}>M</div>
                <div className={styles.myraInfo}>
                  <h2 className={styles.myraName}>Myra</h2>
                  <span className={styles.myraRole}>Recovery Coach</span>
                </div>
              </div>
              { IS_UAT && (
              <div className={styles.modeToggle}>
                <button className={`${styles.modeBtn} ${mode === "chat" ? styles.active : ""}`} onClick={handleChatClicked}>
                  {CHAT_ICON_SVG}Chat
                </button>
                <button className={`${styles.modeBtn} ${mode === "voice" ? styles.active : ""}`} onClick={handleVoiceClicked}>
                    {VOICE_ICON_SVG}Voice
                  </button>
                </div>
              )}
            </div>

            {/* Embedded GSA mount point */}
            <div className={styles.cardBody}>
              <SelfAssessment2 displayMode="embedded" onStartAssessment={handleStartAssessment} onMyraEngagement={handleMyraEngagement} introExternalAction={introExternalAction} />
            </div>

            {/* Card footer: disclaimer */}
            <div className={styles.cardFooter}>
              <p className={styles.disclaimerText}>StartFreePT provides educational guidance based on your input. It is not a substitute for medical advice, diagnosis, or treatment.</p>
            </div>
          </div>

          {/* Copyright below the card */}
          <p className={styles.copyrightText}>&copy; 2026 Virdio Health. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};
